import React from 'react';

const BrandLogo = ({ className = '' }) => (
    <img
        src={`${process.env.PUBLIC_URL}/media/brand-logo.png`}
        alt="lickbeforeyoustick.com"
        className={className ? `brand-logo ${className}` : 'brand-logo'}
        width={240}
        height={80}
        decoding="async"
    />
);

export default BrandLogo;
